import Vue from 'vue'
import App from './App.vue'
import router from "@/router/router";
import i18n from "@/i18n";
import 'iview/dist/styles/iview.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import $ from "jquery";
import iView from "iview";
import mavonEdit from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import VueMarkdown from "vue-markdown/src/VueMarkdown";
import 'github-markdown-css/github-markdown.css'
import hljs from 'highlight.js'
import VueCookies from 'vue-cookies'
import axios from 'axios';
import VueFullpage from 'vue-fullpage.js';
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import * as echarts from 'echarts';
import '@/css/public.css'

Vue.use(VideoPlayer)
Vue.use(VueFullpage);
Vue.use(VueMarkdown);
Vue.use(mavonEdit);
Vue.use(iView);
Vue.use(VueCookies)

Vue.directive('highlight', function (el) {
  const blocks = el.querySelectorAll('pre code')
  blocks.forEach(block => {
    hljs.highlightBlock(block)
  })
})

Vue.prototype.$ = $;
Vue.prototype.$axios = axios;
Vue.prototype.$cookies = VueCookies;
Vue.prototype.$echarts = echarts;

// axios.defaults.baseURL = 'http://localhost:8818/'; //本机测试
axios.defaults.baseURL = ''; // docker

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  i18n
}).$mount('#app')
